import { GridColDef, GridColumns, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { filterOperators } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../cells/base-cell';
import SectionTitle from 'components/common/SectionTitle';

export function MovementVersionsColumns(onOpenDialog: (id: string) => void): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'id',
      headerName: t(`global.version_id`),
      width: 200,
      renderCell: (params) => (
        <div
          onClick={() => {
            onOpenDialog(params.row.id);
          }}
          style={{ cursor: 'pointer', color: '#1976d2' }}>
          <SectionTitle>{params.row.id}</SectionTitle>
        </div>
      )
    },
    {
      field: 'object_value',
      headerName: t(`pages.versions.movement.version_value`),
      filterOperators,
      width: 400,
      renderCell: baseCell
    },
    {
      field: 'timestamp',
      headerName: t(`global.date`),
      filterOperators,
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.value as string);
        return date.toLocaleString('default', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    },
    {
      field: 'actor_name',
      headerName: t(`global.user`),
      filterOperators,
      width: 200,
      renderCell: (params) => {
        const value = params.value;
        return value == null ? 'SYSTEM' : baseCell(params);
      }
    }
  ];
  return columns;
}
